import { useMemo } from "react";

import { createCrmLinksService } from "app/pages/sales-intelligence/modules/company-analysis/services/crm-links/factory";
import type { CompanyCard } from "app/pages/sales-intelligence/modules/company-analysis/types/company";

import MultipleAccountsTagTracked from "./MultipleAccountsTag/MultipleAccountsTagTracked";
import NotConnectedTag from "./NotConnectedTag/NotConnectedTag";
import SingleAccountTagTracked from "./SingleAccountTag/SingleAccountTagTracked";

type CRMIntegrationProps = {
    companyInfo: CompanyCard | undefined;
};

const CRMIntegration = ({ companyInfo }: CRMIntegrationProps) => {
    const integrationsHelper = useMemo(() => {
        return createCrmLinksService(companyInfo);
    }, [companyInfo]);

    if (!companyInfo || !integrationsHelper.hasIntegration()) {
        return <NotConnectedTag />;
    }

    const allAccounts = integrationsHelper.getAllAccounts();

    if (allAccounts.length === 0) {
        return <NotConnectedTag />;
    }

    if (allAccounts.length === 1) {
        return <SingleAccountTagTracked account={allAccounts[0]} />;
    }

    return (
        <MultipleAccountsTagTracked
            accounts={allAccounts}
            preferredAccount={integrationsHelper.getPreferredAccount()}
        />
    );
};

export default CRMIntegration;
